import { catchError, map, Observable, tap } from "rxjs";
import { SessionLengthStats } from "../../models/stats/session-length-stats.model";
import { StoreService } from "..";
import { AdminStatsApiService } from "../../services/api/admin-stats-api.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SessionLengthStatsService {

  constructor(
    private store: StoreService,
    private adminStatsApiService: AdminStatsApiService
  ) { }

  get sessionLengthStats$(): Observable<{ [sessionTemplateId: number]: { [preferredSessionDuration: string]: SessionLengthStats } }> {
    return this.store.state$.pipe(map(state => state.sessionLengthStats));
  }

  load(): Observable<SessionLengthStats[]> {
    this.store.setState({ ...this.store.state, loading: true, error: null });
    return this.adminStatsApiService.getSessionLengthStats().pipe(
      tap(stats => {
        const sessionLengthStats: { [sessionTemplateId: number]: { [preferredSessionDuration: string]: SessionLengthStats } } = {};
        stats.forEach(stat => {
          const byDuration = sessionLengthStats[stat.sessionTemplateId] ?? {};
          byDuration[stat.preferredSessionDuration] = stat;
          sessionLengthStats[stat.sessionTemplateId] = byDuration;
        });
        this.store.setState({
          ...this.store.state,
          sessionLengthStats
        });
      }),
      catchError((error) => {
        this.store.setState({ ...this.store.state, loading: false, error });
        console.error('Error loading session length stats:', error);
        throw error;
      })
    );
  }

  clear(): void {
    const state = { ...this.store.state };
    state.sessionLengthStats = {};
    this.store.setState(state);
  }
}
